<div :class="queueCssClass(serviceInfo)" role="alert">
    <div class="vl-alert__content">
        <template v-if="healthCheckOnly">
            <div class="aeg-queue__infotext aeg-queue__infotext__disabled">
                <div class="aeg-queue__infotext__text">{{ serviceInfo.name }}</div>
                <div class="aeg-queue__service-down" v-if="isServiceDown(serviceInfo)">Service Down!</div>
            </div>
        </template>
        <template v-else-if="counterOnly">
            <template v-if="filter">
                <a href="#" class="aeg-queue__infotext" @click.prevent="gotoSessions()">
                    <div class="aeg-queue__infotext__value">{{ serviceInfo.activeCount }}</div>
                    <div class="aeg-queue__infotext__text">{{ serviceInfo.name }}</div>
                </a>    
            </template>
            <template v-else>
                <div class="aeg-queue__infotext aeg-queue__infotext__disabled">
                    <div class="aeg-queue__infotext__value">{{ serviceInfo.activeCount }}</div>
                    <div class="aeg-queue__infotext__text">{{ serviceInfo.name }}</div>
                </div>
            </template>
        </template>
        <template v-else>
            <router-link protect class="aeg-queue__infotext" :to="{ name: routeAdminServiceDetailName, params: { name: serviceInfo.name } }">
                <div class="aeg-queue__infotext__value">{{ serviceInfo.activeCount }}</div>
                <div class="aeg-queue__infotext__text">{{ serviceInfo.name }}</div>
                <div class="aeg-queue__dead-letters" v-if="serviceInfo.errorCount > 0">
                    {{ serviceInfo.errorCount }} deadletters
                </div>
                <div class="aeg-queue__service-down" v-if="isServiceDown(serviceInfo)">Service Down!</div>
            </router-link>
        </template>
        
    </div>
</div>
